<script setup>
// import xCopy from '../xCopy.vue'
import { useUserStore } from '~/store/user'
import { time2Date } from '#imports'
import UserKycStatus from './UserKycStatus'

const user = useUserStore()
</script>

<template>
  <div class="px-4 py-1 min-w-[432px] max-md:w-full max-md:px-4 max-md:min-w-full">
    <a class="flex rounded-lg p-4 bg-pageTertiary border-b border-border">
      <svgo-header-icon-user class="w-16 h-16 mt-1.5 me-2" />
      <span class="flex flex-col gap-1">
        <span class="text-base font-bold text-textPrimary leading-6">{{ user.info.headerName || '---' }}</span>
        <span class="text-textSecondary text-xs leading-4">{{ $t('上次登录时间') }}：{{ user.info.lastLoginTime ? time2Date(user.info.lastLoginTime, 'y-m-d h:i:s') : '--' }}</span>
        <UserKycStatus />
      </span>
    </a>
  </div>
</template>
